<div>
  <section class="report-section" id="report-pbi">
    <div style="width: 100%; height: 100%" #reportContainer></div>
  </section>
</div>
